<template>
    <div class="w-full flex items-center justify-center py-5" v-if="title.length">
        <div class="flex items-center justify-center mt-4">
            <router-link v-if="hasArrows && previousStep" :to="{ name: previousStep }">
                <img class="h-4 fa-rotate-180 mr-4" src="@/assets/images/decoration/arrow-right-black.svg">
            </router-link>
            <div class="w-50 h-4 flex flex-col items-center justify-center">
                <p class="font-normal text-normal m-0" v-text="title"></p>
                <p v-if="hasArrows" class="font-thin text-sm m-0">{{ step }}/{{ stepsNumber }}</p>
            </div>
            <router-link v-if="hasArrows && nextStep" :to="{ name: nextStep }">
                <img class="h-4 ml-4" src="@/assets/images/decoration/arrow-right-black.svg">
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftProgressSubmenu',
    props: {
        step: {
            required: true,
            type: Number,
        },
        stepsNumber: {
            required: true,
            type: Number,
        },
        previousStep: {
            default: null,
            type: String,
        },
        nextStep: {
            default: null,
            type: String,
        },
        title: {
            required: true,
            type: String,
        },
    },
    computed: {
        hasArrows() {
            return this.step <= this.stepsNumber;
        },
    },
};
</script>
